import { IMAGE_MIN_WIDTH_GRID } from '../../images/imageConstants';

export const ANNOTATION_TYPE = 'ANNOTATION';
export const ANNOTATION_DISPLAY_NAME = 'Annotation';

export const ANNOTATION_MIN_WIDTH = IMAGE_MIN_WIDTH_GRID;
export const ANNOTATION_MIN_HEIGHT = ANNOTATION_MIN_WIDTH;
